import parkings from './parkings';
import parking from './parking';
import session from './session';

export default {
  namespaced: true,
  modules: {
    parkings,
    parking,
    session,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/parkings/index.js